export default __webpack_public_path__ + "static/media/674.1af16c29.gif";